import { Component, Input } from '@angular/core';
import { Company } from 'src/app/domains/companies/models';
import { AUTHORIZATION_METHOD_TYPE, Integration, IntegrationsFilters, IntegrationsResponse } from 'voxloud-types/dist/models/integrations/index';
import { IntegrationsService } from 'src/app/domains/integrations/services/integrations.service';

const PAGE_SIZE = 20;

@Component({
  selector: 'gdp-company-integrations',
  templateUrl: './company-integrations.component.html',
  styleUrls: ['./company-integrations.component.scss']
})

export class CompanyIntegrationsComponent {
  @Input() company: Company;
  filters: IntegrationsFilters;
  public pageSize: number;
  public pagination = {
    page: 0,
    empty: true,
    totalPages: 0
  };
  public integrations: Integration[];
  public AUTH_METHODS = AUTHORIZATION_METHOD_TYPE;
  public loading: boolean;
  public isDeleting: boolean;
  public authMethodsType;
  public isEnabled: boolean;
  public loadingEnabled: boolean;

  constructor(
    private integrationsService: IntegrationsService,
    ) { }

  ngOnInit() {
    this.pageSize = PAGE_SIZE;
    this.filters = {
      company_id: this.company?.companyId
    }
    this.fetchIntegrations();
    this.authMethodsType = this.integrationsService.authMethods;
  }

  fetchIntegrations() {
    this.loading = true;
    this.integrationsService.getIntegrationsByFilter(this.pagination.page, this.pageSize, this.filters).subscribe(
      (response: IntegrationsResponse) => {
        this.integrations = response.content;
        this.integrations.length !== 0 ? this.pagination.totalPages = response.totalPages : this.pagination.totalPages = 1;
        this.loading = false;
      }, 
      () => {
        this.integrations = [];
        this.loading = false;
      });
  }

  selectPageSize(event) { 
    this.pageSize = event;
    this.pagination.page = 0;
    this.fetchIntegrations();
  }

  changeCurrentPage(event) {
    this.pagination = {
      page: event,
      empty: this.integrations.length === 0,
      totalPages: this.pagination.totalPages
    }
    this.fetchIntegrations();
  }

}